import { getApiCall, getCombinedApiCall } from 'Redux/ducks/apiCall/selectors';
import { createSelector } from 'reselect';

import types from './types';

export const getWindowSize = ({ contractGenerator }) => contractGenerator.windowSize;

export const getWindowWidth = ({ contractGenerator }) => contractGenerator.windowSize.width;

export const getWindowHeight = ({ contractGenerator }) => contractGenerator.windowSize.height;

export const getContractId = ({ contractGenerator }) => contractGenerator.contractId;

export const getSessionId = ({ contractGenerator }) => contractGenerator.sessionId;

export const getExtensions = ({ contractGenerator }) => contractGenerator.extensions;

export const getExtension = id =>
	createSelector(getExtensions, extensions => {
		return extensions[id];
	});

export const getFetchExtensionsApiCall = () => getApiCall(types.GET_CALLS.FETCH_EXTENSIONS.REGULAR);

export const getProducts = ({ contractGenerator }) => contractGenerator.products;

export const getProduct = id =>
	createSelector(getProducts, products => {
		return products[id];
	});

export const getFetchProductsApiCall = () => getApiCall(types.GET_CALLS.FETCH_PRODUCTS.REGULAR);

export const getEnableStep2Form = ({ contractGenerator }) => contractGenerator.enableStep2Form;

export const getForms = ({ contractGenerator }) => contractGenerator.forms;

export const getFetchEnableStep2FormApiCall = () => getApiCall(types.GET_CALLS.FETCH_ENABLE_STEP_2_FORM.REGULAR);

export const getFetchFormsApiCall = () => getApiCall(types.GET_CALLS.FETCH_FORMS.REGULAR);

export const getFormFields = ({ contractGenerator }) => contractGenerator.formFields;

export const getFetchFormFieldsApiCall = () => getApiCall(types.GET_CALLS.FETCH_FORM_FIELDS.REGULAR);

export const getConstants = ({ contractGenerator }) => contractGenerator.constants;

export const getUser = ({ contractGenerator }) => contractGenerator.user;

export const getFetchConstantsApiCall = () => getApiCall(types.GET_CALLS.FETCH_CONSTANTS.REGULAR);

export const getActiveStep = ({ contractGenerator }) => contractGenerator.activeStep;

export const getDataToSubmit = ({ contractGenerator }) => contractGenerator.userInput.dataToSubmit;

export const getBlockedFields = ({ contractGenerator }) => contractGenerator.userInput.blockedFields;

export const getDiscountDataToSubmit = ({ contractGenerator }) => contractGenerator.discountSettings.dataToSubmit;

export const getDiscountFieldInfo = ({ contractGenerator }) => contractGenerator.discountSettings.fieldInfo;

export const getSelectedRooms = ({ contractGenerator }) => contractGenerator.userInput.dataToSubmit.selectedRooms;

export const getSelectedAccommodationType = ({ contractGenerator }) => contractGenerator.userInput.dataToSubmit.selectedAccommodationType;

export const getSelectedProduct = ({ contractGenerator }) => contractGenerator.userInput.dataToSubmit.selectedProduct;

export const getSelectedExtensions = ({ contractGenerator }) => contractGenerator.userInput.dataToSubmit.selectedExtensions;

export const getSelectedContractTermInMonths = ({ contractGenerator }) =>
	contractGenerator.userInput.dataToSubmit.selectedContractTermInMonths;

export const getSelectedPaymentType = ({ contractGenerator }) => contractGenerator.userInput.dataToSubmit.selectedPaymentType;

export const getFormData = ({ contractGenerator }) => contractGenerator.userInput.dataToSubmit.formData;

export const getCaptchaResponse = ({ contractGenerator }) => contractGenerator.userInput.dataToSubmit.captchaResponse;

export const getFieldInfo = ({ contractGenerator }) => contractGenerator.userInput.fieldInfo;

export const getSubmitApiCall = () => getApiCall(types.POST_CALLS.SUBMIT.REGULAR);

export const getActivateStep2ApiCall = () => getApiCall(types.POST_CALLS.ACTIVATE_STEP_2.REGULAR);

export const getSaveSessionApiCall = () => getApiCall(types.POST_CALLS.SAVE_SESSION.REGULAR);

export const getFetchSessionApiCall = () => getApiCall(types.GET_CALLS.FETCH_SESSION.REGULAR);

export const getCheckUserSessionApiCall = () => getApiCall(types.GET_CALLS.CHECK_USER_SESSION.REGULAR);

export const getLoginApiCall = () => getApiCall(types.POST_CALLS.LOGIN.REGULAR);

export const getFetchApiCalls = () =>
	getCombinedApiCall([
		types.GET_CALLS.FETCH_EXTENSIONS.REGULAR,
		types.GET_CALLS.FETCH_PRODUCTS.REGULAR,
		types.GET_CALLS.FETCH_ENABLE_STEP_2_FORM.REGULAR,
		types.GET_CALLS.FETCH_FORMS.REGULAR,
		types.GET_CALLS.FETCH_FORM_FIELDS.REGULAR,
		types.GET_CALLS.FETCH_CONSTANTS.REGULAR,
		types.GET_CALLS.FETCH_SESSION.REGULAR,
		types.GET_CALLS.CHECK_USER_SESSION.REGULAR
	]);
